import { MetricSet } from 'api/model'
import { capitalizeFirstLetter } from 'utils'
import Selector from 'components/Selector'

const MetricSetSelector = ({
  metricSet,
  setMetricSet,
}: {
  metricSet: MetricSet
  setMetricSet: (metricSet: MetricSet) => void
}) => {
  return (
    <Selector
      id="metric-set-selector"
      isDarkBackdrop={true}
      label="Metrics set"
      option={metricSet}
      options={Object.values(MetricSet)}
      setOption={setMetricSet}
      width="280px"
      renderCustomOption={(option) => capitalizeFirstLetter(option)}
    />
  )
}

export default MetricSetSelector
